import { HeaderFormBlock } from 'models/common/form/formContentBlock/HeaderFormBlock';

export default class HeaderFormBlockService {
	toModel(formBlock) {
		return new HeaderFormBlock(formBlock);
	}
}
